import { LS } from "../_helpers";
import { currentUserConstants } from "../_constants";

const {
  CHANGE_USER,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_FAIL,
} = currentUserConstants;

const initialState = {
  user: {},
  permissions: [],
  accessToken: null,
  currentUser: null,
  error: null,
};

const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_USER:
      return {
        ...state,
        currentUser: action.payload,
      };
    case GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        error: null,
      };
    case GET_USER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PERMISSIONS_SUCCESS:
      localStorage.clear();
      let userType = null;
      if (action.payload.includes(" ADMIN_LENDING_SERVICE")) {
        userType = "admin";
        LS.save("currentUser", {
          userType: userType,
          ...state.user,
        });
      }
      return {
        ...state,
        permissions: action.payload,
        currentUser: { userType },
        error: null,
      };
    case GET_PERMISSIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default currentUserReducer;
